import { AdminApi } from "./generated-src";
import { getAppSetting } from "../config/AppSettings";

export default function () {
  const apiBasePath = `${getAppSetting("apiUrl")}/jwt`;
  //const apiBasePath = process.env.NODE_ENV === 'production' ? `https://${getAppSetting('apiUrl')}/jwt` : `http://localhost:3000/jwt`;
  return new AdminApi(undefined, apiBasePath);
}
